import { Injectable, inject } from "@angular/core";
import { Query, ResolverParams, ResolverService } from "./api/resolver.service";
import { KFeathers } from "./api/feathers.service";
import * as _ from "lodash-es";
import { Customer, ICustomer } from "../models/customer.model";
import { Contact } from "../models/customer-contact";


@Injectable({ providedIn: 'root' })
export class CustomerContactService extends ResolverService<Contact> {
    protected feather: KFeathers;

    path: string = 'customers_contacts';
    model: new (any: any) => Contact = Contact;

    constructor() {
        const feather = inject(KFeathers);

        super(feather);
    
        this.feather = feather;
    }

}